import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useLoggedInStatusForTrackingConsent = (
  isUserLoggedIn: boolean,
): void => {
  useEffect(() => {
    if (isUserLoggedIn) {
      datadogRum.setTrackingConsent('granted');
    }
  }, [isUserLoggedIn]);
};
